import { IonIcon, IonProgressBar } from "@ionic/react";
import { checkIcon } from "@/lib/icons/@heroicons/react/16/solid";
import { cx } from "@/lib/style/cva.config";

export function ProgressBar({ value }: { value: number }) {
	return (
		<div className="relative isolate flex h-5 w-full items-center">
			<IonProgressBar
				value={value}
				className={cx("!ion-bg-brown-200 !ion-progress-bg-brown-400 h-2", {
					"!ion-progress-bg-orange-500": value >= 1,
				})}
			/>
			<div
				aria-checked={value >= 1}
				className="bg-brown-200 absolute inset-y-0 right-0 z-10 grid size-5 place-content-center rounded-full text-transparent aria-checked:bg-[#DC6803] aria-checked:text-white"
			>
				<IonIcon icon={checkIcon} className="size-4" />
			</div>
		</div>
	);
}
